<template>
  <div class="grid grid-cols-2 col-gap-14 row-gap-4">
    <div class="col-span-2">
      <h1>Settings</h1>
    </div>
    <div>
      <base-label>Name</base-label>
      <base-input v-model="outfitter.name" @blur="silentSave" />
    </div>
    <div>
      <base-label>Tag Line</base-label>
      <base-input v-model="outfitter.tag_line" @blur="silentSave" />
    </div>
    <div>
      <base-label>Email</base-label>
      <base-input v-model="outfitter.email" @blur="silentSave" />
    </div>
    <div class="grid grid-cols-3 gap-4">
      <div>
        <base-label class="text-center">Body Color</base-label>
        <div
          class="colorBlock mx-auto"
          @click="showBodyColor = !showBodyColor"
          :style="{ 'background-color': outfitter.body_color }"
        ></div>
        <color-picker
          :show-modal="showBodyColor"
          @close="showBodyColor = false"
          @save="handleBodyColorSave"
          title="Body Color"
          :value="outfitter.body_color"
        ></color-picker>
      </div>
      <div>
        <base-label class="text-center">Header Color</base-label>
        <div
          class="colorBlock mx-auto"
          @click="showHeaderColor = !showHeaderColor"
          :style="{ 'background-color': outfitter.header_color }"
        ></div>
        <color-picker
          :show-modal="showHeaderColor"
          @close="showHeaderColor = false"
          @save="handleHeaderColorSave"
          title="Header Color"
          :value="outfitter.header_color"
        ></color-picker>
      </div>
      <div>
        <base-label class="text-center">Text Color</base-label>
        <div
          class="colorBlock mx-auto"
          @click="showTextColor = !showTextColor"
          :style="{ 'background-color': outfitter.text_color }"
        ></div>
        <color-picker
          :show-modal="showTextColor"
          @close="showTextColor = false"
          @save="handleTextColorSave"
          title="tEXT Color"
          :value="outfitter.text_color"
        ></color-picker>
      </div>
    </div>

    <div>
      <base-label>Trip Advisor Reviews</base-label>
      <base-input v-model="outfitter.trip_advisor" @blur="silentSave" />
    </div>
    <div>
      <base-label>Google Reviews</base-label>
      <base-input v-model="outfitter.google" @blur="silentSave" />
    </div>
    <div>
      <base-label>Facebook</base-label>
      <base-input v-model="outfitter.facebook" @blur="silentSave" />
    </div>

    <div>
      <base-label>Twitter</base-label>
      <base-input v-model="outfitter.twitter" @blur="silentSave" />
    </div>
    <div>
      <base-label>Instagram</base-label>
      <base-input v-model="outfitter.instagram" @blur="silentSave" />
    </div>

    <div>
      <base-label>Website URL</base-label>
      <base-input v-model="outfitter.website" @blur="silentSave" />
    </div>
    <div>
      <base-label>Website Label</base-label>
      <base-input v-model="outfitter.website_label" @blur="silentSave" />
    </div>

    <div>
      <base-label>Page Meta Title</base-label>
      <base-input v-model="outfitter.meta_title" @blur="silentSave" />
    </div>
    <div>
      <base-label>Page Meta Description</base-label>
      <base-input v-model="outfitter.meta_description" @blur="silentSave" />
    </div>

    <div>
      <base-label>Upload Logo</base-label>
      <input
        type="file"
        name="photos"
        @change="filesChange($event.target.files)"
        accept="image/*"
      />
    </div>

    <div>
      <base-label>Existing Logo</base-label>
      <img :src="this.outfitter.logo_path" class="logo" />
    </div>

    <div>
      <base-label>Local Link</base-label>
      <div>
        <a target="_blank" :href="localLink()">{{ localLink() }}</a>
      </div>
    </div>
    <div>
      <base-label>External Link</base-label>
      <div>
        <a target="_blank" :href="externalLink()">{{ externalLink() }}</a>
      </div>
    </div>
    <div>
      <base-label>Cart Timeout <i>(In Seconds)</i></base-label>
      <base-input v-model="outfitter.cart_timeout" @blur="silentSave" />
    </div>
    <div></div>

    <div class="w-full">
      <base-button-primary @click="save">Save</base-button-primary>
    </div>
  </div>
</template>

<script>
import ColorPicker from "@/components/ui/elements/ColorPicker";
export default {
  name: "Settings",
  components: { ColorPicker },
  data() {
    return {
      showBodyColor: false,
      showHeaderColor: false,
      showTextColor: false,
    };
  },
  methods: {
    handleBodyColorSave(color) {
      color = color ? color : "#FFFFFF";
      this.outfitter.body_color = color;
      this.showBodyColor = false;
      this.silentSave();
    },
    handleHeaderColorSave(color) {
      color = color ? color : "#FFFFFF";
      this.outfitter.header_color = color;
      this.showHeaderColor = false;
      this.silentSave();
    },
    handleTextColorSave(color) {
      color = color ? color : "#FFFFFF";
      this.outfitter.text_color = color;
      this.showTextColor = false;
      this.silentSave();
    },
    filesChange(fileList) {
      if (!fileList.length) return;

      let acceptedFiles = ["image/jpeg", "image/jpg", "image/png"];
      fileList.forEach((file) => {
        if (acceptedFiles.includes(file.type)) {
          this.$notify({
            title: "Logo",
            message: "Saving Logo",
            type: "success",
          });

          this.$store.dispatch("outfitter/save_logo", {
            file,
            id: this.outfitter.id,
          });
        } else {
          this.$notify({
            title: "Photo",
            message: "File type " + file.type + " is not allowed",
            type: "error",
          });
        }
      });
    },
    localLink() {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/outfitter/" +
        this.outfitter.slug
      );
    },
    externalLink() {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/outfitter/" +
        this.outfitter.slug +
        "/external"
      );
    },
    save() {
      this.$store
        .dispatch("outfitter/save_outfitter", this.outfitter)
        .then((resp) => {
          if (!resp.success) return;

          this.$notify({
            title: "Outfitter",
            message: "Data Saved",
            type: "success",
          });
        });
    },
    silentSave() {
      this.$store.dispatch("outfitter/save_outfitter", this.outfitter);
    },
  },
  computed: {
    rivers: function () {
      return this.$store.getters["site/getRivers"];
    },
    outfitter: function () {
      return this.$store.getters["outfitter/getOutfitter"];
    },
  },
  mounted() {
    this.$store.dispatch("site/get_rivers");
  },
};
</script>
<style scoped>
.logo {
  max-width: 300px;
  max-height: 75px;
}
.colorBlock {
  width: 50px;
  height: 50px;
  border: 1px solid #0e0e0e;
  cursor: pointer;
}
</style>
